import * as Joi from 'joi';

const accessArrangementRequestSchema = (maxLength: number) =>
  Joi.object({
    uuid: Joi.string().allow(''),
    requestTypeUuid: Joi.string().required(),
    remarks: Joi.string().allow('').max(maxLength),
    subjectPapers: Joi.array().required().items(Joi.object()).has(Joi.object()),
  });
export default accessArrangementRequestSchema;
